<!--start header-->
<header id="home" style="height: 320px!important;position: relative;" >
  <div class="header-slider" style="height: 100%;">
      <!-- <div class="overlay"></div> -->
      
      <owl-carousel [options]="sliderOptions"  [carouselClasses]="['owl-theme', 'sliding']">
          <div class="item" *ngFor="let image of siderImages;let i = index">
              <div class="slick-item">
                  <img class="sliderImage" style="width: 100%;background-size: contain;height: 320px!important;" src="./assets/{{image.ImagePath}}"/>
              </div>
          </div>
      </owl-carousel> 
      
  </div>
</header>
<!--End header-->
<section class="mainProductsSection" id="mainProductsSection" style="padding-top: 200px;">
  <div class="container-fluid">
    <div class="row">
      <main class="productsList col-md-8 col-lg-8">
      <mat-tab-group > 
          <mat-tab label="Search Result">
            <span *ngFor="let item of itemsList">
              <div class="search-results">
                <app-product-card [item]="item"></app-product-card>
              </div>
            </span>  
         </mat-tab>	      
        </mat-tab-group>
        <div class="my-container">
          <ng-template #customLoadingTemplate>
              <div class="custom-class">
              </div>
          </ng-template>
       
         <ngx-loading [show]="loading" [config]="{ primaryColour:'#0c3131' ,secondaryColour: '#0c3131',tertiaryColour:'#0c3131',backdropBackgroundColour:'rgba(57, 168, 208, 0.3)', backdropBorderRadius: '3px' ,fullScreenBackdrop:true }" [template]="customLoadingTemplate"></ngx-loading>
     
        </div>
      </main>
      <!--Filter ... -->
      <!-- <div class="filterAndSort col-lg-2 col-lg-offset-1" [style.text-align]="txtDir == 'ltr'?'left':'right'" [style.margin-left]="txtDir == 'ltr'?'6%':'0%'" [style.margin-right]="txtDir == 'ltr'?'0%':'6%'" 
      style="margin-top:50px;border: 1px solid rgb(0, 150, 136,0.3);border-radius: 3px; height: 320px;">
        <div style="margin: auto;margin-top: 20px;margin-left: 5%;">
          <form>
            <select #mySelect
            (change)='SortBy(mySelect.value)' class="form-control">
              <option [value]="0"> SortBy</option>
              <option [value]="1"> Price: Low to High</option>
              <option [value]="2"> Price: High To Low </option>
              <option [value]="3"> Most Recent </option>
              <option [value]="4"> Most Ordered</option>
            </select>
          </form>
        </div><hr style="border-top: 1px solid rgb(0, 150, 136,0.5);
        position: relative;  width: 93%;left: 4px;margin-bottom: 28px;"> 
         <div style="margin: auto;margin-top: 20px;margin-left: 5%;">
            <h5 style="font-weight: bold;color:rgb(0, 150, 136) ;margin-bottom: 15px">{{translation['Availability']}}</h5>
            <form>
              <input type="radio" name="available" value="1" 
              (change)="FilterBy($event.target.value)"> {{translation['available']}}<br>
              <input type="radio" name="available" value="2"
              (change)="FilterBy($event.target.value)" checked>{{translation['all']}}
            </form>
          </div><hr style="border-top: 1px solid rgb(0, 150, 136,0.5);
          position: relative;  width: 93%;left: 4px;margin-bottom: 28px;">
          <div style="margin-top: 20px;">
            <h5 style="font-weight: bold;color:rgb(0, 150, 136) ;">{{translation['price']}}</h5>
            <mat-slider thumbLabel [displayWith]="formatLabel"
            tickInterval="1000" #gridsize (change)="updateEndPrice($event)"  [min]="min" [max]="max" [value]="gridsize"></mat-slider>
          </div>

          
      </div> -->
    </div>
  </div> 
</section>
